import { ChangeDetectionStrategy, Component, Input, output, OutputEmitterRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DsButtonIntent, DsButtonVariants, DsModalModule, DsModule } from '@levelaccess/design-system';
import { Observable } from 'rxjs';

import { CommonPipesModule } from '@client/app/shared/common-pipes.module';
import { CustomValidators } from '@client/app/services/helpers/form-custom-validators';
import { FormService } from '@client/app/services/form.service';
import { AngularUtility } from '@client/app/utility/angular.utility';
import { AI_CHAT_SESSION_TITLE_MAX_LENGTH } from '../../../../../shared/interfaces/ai-chat.interface';

@Component({
  selector: 'app-ai-chat-rename-modal',
  templateUrl: './ai-chat-rename-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, CommonPipesModule, DsModalModule, DsModule, ReactiveFormsModule],
})
export class AiChatRenameModalComponent {
  @Input({ required: true }) public set currentTitle(value: string) {
    this.form.patchValue({ title: value });
  }

  public readonly save: OutputEmitterRef<string> = output<string>();

  public readonly DsButtonVariants: typeof DsButtonVariants = DsButtonVariants;
  public readonly DsButtonIntent: typeof DsButtonIntent = DsButtonIntent;
  public readonly charLimit: number = AI_CHAT_SESSION_TITLE_MAX_LENGTH;
  public readonly titleError$: Observable<string | null>;
  public readonly form: FormGroup<{ title: FormControl<string> }>;

  constructor(
    public modal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private formService: FormService,
  ) {
    this.form = this.formBuilder.nonNullable.group({
      title: ['', [CustomValidators.validateIsEmpty, Validators.maxLength(this.charLimit)]],
    });
    this.titleError$ = this.formService
      .buildFormControlErrorMessage$(this.form.controls.title, 'label_chat_session_title')
      .pipe(AngularUtility.shareRef());
  }

  public onSubmit(): void {
    this.form.controls.title.updateValueAndValidity();
    if (this.form.invalid) {
      return;
    }
    this.save.emit(this.form.controls.title.value.trim());
    this.modal.close();
  }
}
